import component from "./Publication"

export default { 
    component, 
    urlHash: "#publication" 
}